import React, { useEffect, useState } from "react";
import {
  Drawer,
  Select,
  Input,
  InputNumber,
  Button,
  message,
  Spin,
} from "antd";
import axios from "axios";
import { BASE_CRM_URL } from "../../../components/config/config";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

const { TextArea } = Input;

const EditProduct = ({ open, onClose, getProducts, record }) => {
  const [loading, setLoading] = useState(false);
  console.log(record, "recordddddddddddd");
  const [image, setImage] = useState(null);
  console.log(image);
  const [preview, setPreview] = useState(null);

  const [formData, setFormData] = useState({
    description: "",
    long_description: "",
    rate: "",
    unit: "",
    group_id: null,
    rate_currency_1: "0",
    origin: "India",
    hsn: "",
    commodity_code: "",
    commodity_name: "",
    Quantity: 1,
  });

  useEffect(() => {
    if (record) {
      setFormData({
        description: record.description || "",
        long_description: record.long_description || "",
        rate: record.price ?? "",
        unit: record.unit || "",
        hsn: record.HSNCode,
      });
      setSelectedTax1(record.tax1 ?? null);

      // Preselect Tax 2
      setSelectedTax2(record.tax2 ?? null);

      // Preselect Group
      setSelectGroup(record.group_id ?? null);
    }
  }, [record]);

  useEffect(() => {
    if (record) {
      setFormData({
        description: record.description || "",
        long_description: record.long_description || "",
        rate: record.price ?? "",
        unit: record.unit || "",
        hsn: record.HSNCode || "",
        group_id: record.group_id ?? null,
        rate_currency_1: record.rate_currency_1 ?? "",
        origin: record.origin || "India",
        long_descriptions: record.long_descriptions || "",
        Quantity: record.quantity ?? 1,
      });

      setSelectedTax1(record.tax1 ?? null);
      setSelectedTax2(record.tax2 ?? null);
      setSelectGroup(record.group_id ?? null);

      // Existing product image
      if (record.image_url) {
        setPreview(record.image_url);
      } else if (record.external_link) {
        setPreview(`${record.external_link}`);
      } else {
        setPreview(null);
      }

      // Important: existing image is NOT a new file
      setImage(null);
    }
  }, [record]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!open) {
      setImage(null);
      setPreview(null);

      setFormData({
        description: "",
        long_description: "",
        rate: "",
        tax: 0,
        tax2: 0,
        unit: "",
        group_id: 1,
        rate_currency_1: "",
        origin: "",
        long_descriptions: "",
        commodity_code: "",
        commodity_name: "",
        Quantity: 0,
      });

      setErrors({});
    }
  }, [open]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleFile = (file) => {
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      message.warning("Please select an image file.");
      return;
    }

    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleInputChange = (e) => {
    handleFile(e.target.files[0]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.description?.trim()) {
      newErrors.description = "Description is required";
    }

    if (
      formData.rate === "" ||
      formData.rate === null ||
      formData.rate === undefined
    ) {
      newErrors.rate = "Rate is required";
    }

    if (!formData.unit?.trim()) {
      newErrors.unit = "Unit is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [taxOptions, setTaxOptions] = useState([]);

  const [taxLoading, setTaxLoading] = useState(false);

  const [selectedTax1, setSelectedTax1] = useState(null);
  const [selectedTax2, setSelectedTax2] = useState(null);

  const getTaxes = async () => {
    try {
      setTaxLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetTaxes`);

      const data = await response.json();

      if (data.Status) {
        const options = (data.ResultData || []).map((item) => ({
          value: item.Id,
          label: item.Name,
          taxrate: Number(item.taxrate || 0),
        }));

        setTaxOptions(options);
      } else {
        setTaxOptions([]);
      }
    } catch (error) {
      console.error("Error fetching taxes:", error);
      setTaxOptions([]);
    } finally {
      setTaxLoading(false);
    }
  };

  const [groupOptions, setGroupOptions] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const [selectGroup, setSelectGroup] = useState(null);

  const getProductGroups = async () => {
    try {
      setGroupLoading(true);

      const response = await fetch(`${BASE_CRM_URL}products/GetProductGroups`);

      const data = await response.json();

      if (data.Status) {
        const options = (data.Data || []).map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setGroupOptions(options);
      } else {
        setGroupOptions([]);
      }
    } catch (error) {
      console.error("Get Product Groups Error:", error);
      setGroupOptions([]);
    } finally {
      setGroupLoading(false);
    }
  };

  useEffect(() => {
    getTaxes();
    getProductGroups();
  }, []);
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const payload = new FormData();

      payload.append("id", record.id);
      payload.append("description", formData.description || "");
      payload.append("long_description", formData.long_description || "");
      payload.append("rate", Number(formData.rate || 0));
      payload.append("tax", Number(selectedTax1 || 0));
      payload.append("tax2", Number(selectedTax2 || 0));
      payload.append("unit", formData.unit || "");
      payload.append("hsn", formData.hsn || "");
      payload.append("group_id", Number(selectGroup || 0));

      payload.append(
        "rate_currency_1",
        Number(formData.rate_currency_1 || formData.rate || 0),
      );

      payload.append("origin", formData.origin || "");
      payload.append("long_descriptions", formData.long_descriptions || "");
      payload.append("commodity_code", formData.commodity_code || "");
      payload.append("commodity_name", formData.commodity_name || "");
      // payload.append("quantity", Number(formData.Quantity || 0));

      // Only send file when user selected a NEW image
      if (image) {
        payload.append("file", image);
      }

      console.log("Update Product FormData:");

      for (const [key, value] of payload.entries()) {
        console.log(key, value);
      }

      const response = await axios.post(
        `${BASE_CRM_URL}products/UpdateProduct`,
        payload,
      );

      if (response.data?.Status) {
        Swal.fire({
          title: "Success",
          text: response.data?.Message || "Product updated successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await getProducts();
            onClose?.();
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: response.data?.Message || "Failed to update product",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Update Product API Error:", error);

      message.error(
        error.response?.data?.Message || "Failed to update product",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <Drawer
        title={
          <div className="d-flex justify-content-between align-items-center w-100">
            <span>Update New Product</span>

            <div className="d-flex align-items-center gap-2">
              {/* Close Drawer */}
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#e40d22",
                  color: "#fff",
                  border: "none",
                }}
                title="Close"
              >
                <i className="fa fa-times" />
              </button>

              {/* Save */}
              <button
                type="button"
                onClick={handleUpdate}
                disabled={loading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#07f083",
                  color: "#fff",
                  border: "none",
                }}
                title="Save"
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  <i className="fa fa-check" />
                )}
              </button>
            </div>
          </div>
        }
        closable={false}
        placement="right"
        width={500}
        open={open}
        onClose={onClose}
        destroyOnClose

        // footer={
        //   <div className="d-flex justify-content-end">
        //     <Button className="me-2" onClick={onClose} disabled={loading}>
        //       Close
        //     </Button>

        //     <Button type="primary" loading={loading} onClick={handleUpdate}>
        //       Save
        //     </Button>
        //   </div>
        // }
      >
        <form onSubmit={handleUpdate}>
          {/* <div className="mb-3">
          <label className="form-label">
            <span className="text-danger">*</span> Product Image
          </label>

          <div
            className="border border-2 border-secondary border-dashed rounded text-center p-4"
            style={{
              cursor: "pointer",
              minHeight: "220px",
            }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onClick={() => document.getElementById("productImage")?.click()}
          >
            <input
              id="productImage"
              type="file"
              accept="image/*"
              hidden
              onChange={handleInputChange}
            />

            {preview ? (
              <>
                <img
                  src={preview}
                  alt="Preview"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "180px",
                    objectFit: "contain",
                  }}
                />

                <div>
                  <Button
                    type="default"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      document.getElementById("productImage")?.click();
                    }}
                  >
                    <i className="fa-solid fa-pen me-2"></i>
                    Change Image
                  </Button>
                </div>
              </>
            ) : (
              <>
                <i className="fa-regular fa-image fa-3x text-secondary mb-3"></i>

                <h6 className="mb-2">Drag & Drop an image here</h6>

                <p className="text-muted mb-3">
                  or click to browse from your computer
                </p>

                <Button type="primary">
                  <i className="fa-solid fa-upload me-2"></i>
                  Choose Image
                </Button>

                <div className="small text-muted mt-3">
                  Supported: JPG, PNG, JPEG, WEBP
                </div>
              </>
            )}
          </div>
        </div> */}
          <div className="mb-3">
            <label className="form-label">
              <span className="text-danger">*</span> Product Image
            </label>

            <div
              className="border border-2 border-secondary border-dashed rounded text-center p-4"
              style={{
                minHeight: "220px",
              }}
              onDrop={handleDrop}
              onDragOver={handleDragOver}
            >
              <input
                id="productImage"
                type="file"
                accept="image/*"
                hidden
                onChange={handleInputChange}
              />

              {preview ? (
                <>
                  <img
                    src={preview}
                    alt="Product"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "180px",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />

                  <div>
                    <Button
                      type="default"
                      size="small"
                      onClick={() =>
                        document.getElementById("productImage")?.click()
                      }
                    >
                      <i className="fa-solid fa-pen me-2"></i>
                      Change Image
                    </Button>
                  </div>

                  {image && (
                    <div className="small text-success mt-2">
                      New image selected: {image.name}
                    </div>
                  )}
                </>
              ) : (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    document.getElementById("productImage")?.click()
                  }
                >
                  <i className="fa-regular fa-image fa-3x text-secondary mb-3"></i>

                  <h6 className="mb-2">Drag & Drop an image here</h6>

                  <p className="text-muted mb-3">
                    or click to browse from your computer
                  </p>

                  <Button type="primary">
                    <i className="fa-solid fa-upload me-2"></i>
                    Choose Image
                  </Button>

                  <div className="small text-muted mt-3">
                    Supported: JPG, PNG, JPEG, WEBP
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">
              <span className="text-danger">*</span> Description
            </label>

            <TextArea
              rows={2}
              placeholder="Description"
              value={formData.description}
              onChange={(e) => handleChange("description", e.target.value)}
              status={errors.description ? "error" : ""}
            />

            {errors.description && (
              <div className="text-danger small mt-1">{errors.description}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Long Description</label>

            <TextArea
              rows={3}
              placeholder="Long Description"
              value={formData.long_description}
              onChange={(e) => handleChange("long_description", e.target.value)}
            />
          </div>

          <div className="row">
            <div className="col-6 mb-3">
              <label className="form-label">
                <span className="text-danger">*</span> Rate - INR
              </label>

              <InputNumber
                className="w-100"
                style={{ height: 38 }}
                placeholder="Rate"
                min={0}
                value={formData.rate}
                onChange={(value) => {
                  handleChange("rate", value);

                  if (
                    formData.rate_currency_1 === "" ||
                    formData.rate_currency_1 === null
                  ) {
                    handleChange("rate_currency_1", value);
                  }
                }}
                status={errors.rate ? "error" : ""}
              />

              {errors.rate && (
                <div className="text-danger small mt-1">{errors.rate}</div>
              )}
            </div>

            <div className="col-6 mb-3">
              <label className="form-label">Item Group</label>

              <Select
                className="w-100"
                placeholder="Select Item Group"
                loading={groupLoading}
                style={{ height: 38 }}
                allowClear
                value={selectGroup || undefined}
                // onChange={(value) => handleChange("group_id", value)}
                onChange={(value) => {
                  setSelectGroup(value);
                }}
                options={groupOptions}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6 mb-3">
              <label className="form-label">Tax 1</label>

              <Select
                className="w-100"
                placeholder="Select Tax"
                loading={taxLoading}
                options={taxOptions}
                value={selectedTax1}
                onChange={(value) => {
                  setSelectedTax1(value);
                }}
                style={{ height: 38 }}
                allowClear
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Tax 2</label>

              <Select
                className="w-100"
                placeholder="Select Tax"
                options={taxOptions}
                loading={taxLoading}
                style={{ height: 38 }}
                value={selectedTax2}
                onChange={(value) => {
                  setSelectedTax2(value);
                }}
                allowClear
              />
            </div>
          </div>

          <div className="row">
            <div className="col-6 mb-3">
              <label className="form-label">
                <span className="text-danger">*</span> Unit
              </label>

              <Input
                placeholder=" Enter Unit"
                value={formData.unit}
                onChange={(e) => handleChange("unit", e.target.value)}
                status={errors.unit ? "error" : ""}
                style={{ height: 38 }}
              />

              {errors.unit && (
                <div className="text-danger small mt-1">{errors.unit}</div>
              )}
            </div>

            <div className="col-6 mb-3">
              <label className="form-label">
                <span className="text-danger">*</span> HSN
              </label>

              <Input
                placeholder=" Enter HSN"
                value={formData.hsn}
                onChange={(e) => handleChange("hsn", e.target.value)}
                status={errors.unit ? "error" : ""}
                style={{ height: 38 }}
              />

              {errors.hsn && (
                <div className="text-danger small mt-1">{errors.hsn}</div>
              )}
            </div>
          </div>
        </form>
      </Drawer>
    </div>
  );
};

EditProduct.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  record: PropTypes.object,
};

export default EditProduct;
